import React from 'react'
import {useTranslation} from "react-i18next";
import parseHTML from "html-react-parser";
import "./styles/PopupGeneratedProjectsList.scss"

interface IPopupExportGenerating {
	popup: string
	data: string
}

export const PopupExportGenerating: React.FC<IPopupExportGenerating> = ({popup, data}) => {

	const {t} = useTranslation();

	return (

		<div className="popup-body">
			<div className="generating-export__container popup-container" data-simplebar>
				<h2 className="generating-export__title title">
					{parseHTML(t("analytics_export.loading_title"))}
				</h2>
				<div className="generating-export__text">
					{parseHTML(t("analytics_export.loading_text"))}
				</div>
				<div className="generating-export__loader">
					<div className="loader"></div>
				</div>
				<i className="generating-export__status">
					{data}
				</i>
			</div>
		</div>
	)
}
